<div>
  <table class="timespots table">
    <tr>
      <td class="table-row"></td>
      <td class="table-row"></td>
    </tr>
    <tr>
      <td class="table-row label-field">Promo Day Switching Hour:</td>
      <td class="table-row">
        <icn-time-picker
          class="time-picker"
          [timeInMinutes]="channel.workingHours.startTimeInMinutes"
          (timeInMinutesChange)="
            channel.workingHours.startTimeInMinutes = $event;
            channel.workingHours.endTimeInMinutes = $event
          "
        ></icn-time-picker
        ><span class="label display-inline m20"></span>
      </td>
    </tr>
    <tr>
      <td class="table-row label-field">First Day of Week:</td>
      <td class="table-row">
        <icn-day-of-week-picker
          [selectedDay]="channel.workingHours.startDayOfWeek"
          (onChange)="
            channel.workingHours.startDayOfWeek = $event;
            channel.workingHours.endDayOfWeek = $event
          "
        ></icn-day-of-week-picker
        ><span class="label display-inline m20"></span>
      </td>
    </tr>

    <tr>
      <td class="table-row"></td>
      <td class="table-row"></td>
    </tr>
    <tr>
      <td class="table-header">WHEN</td>
      <td class="table-header pl8">TEXT</td>
    </tr>
    <ng-container *ngFor="let timespot of timespots">
      <tr>
        <td class="table-row">
          <icn-dropdown
            [disabled]="timespot.timeSpotType == 6"
            [textAlign]="'left'"
            [selectedValue]="timespot.timeSpotType"
            (selectedValueChange)="onTypeChange(timespot, $event)"
          >
            <icn-dropdown-item
              *ngFor="
                let timeSpotType of timespotTypes.filter(
                  filterTimespotType(timespot)
                )
              "
              [title]="timeSpotType.name"
              [value]="timeSpotType.type"
            >
            </icn-dropdown-item>
          </icn-dropdown>
        </td>
        <td class="table-row pl8">
          <input
            type="text"
            class="timespot-text-input"
            [(ngModel)]="timespot.text"
          />
        </td>
        <td class="table-row pl8 pr8">
          <div *ngIf="timespot.timeSpotType != 6">
            <remove-button
              data-title="DELETE"
              (click)="deleteTimespot(timespot)"
              [overrideClass]="'hover-black'"
            ></remove-button>
          </div>
        </td>
        <td class="table-row">
          <a
            *ngIf="timespot.timeSpotType == 2 || timespot.timeSpotType == 3"
            href="#"
            class="button add-extended-settings"
            (click)="addExtendedSettings(timespot)"
            >+ Add Hours</a
          >
        </td>
      </tr>
      <tr *ngIf="timespot.extentedSettings">
        <td class="table-row extented-settings-row first">
          <div class="time-picker-field">
            <label class="label">From</label
            ><icn-time-picker
              class="time-picker"
              [timeInMinutes]="timespot.extentedSettings.offsetFrom"
              (timeInMinutesChange)="
                timespot.extentedSettings.offsetFrom = $event
              "
            ></icn-time-picker>
          </div>
          <div class="time-picker-field">
            <label class="label">To</label
            ><icn-time-picker
              class="time-picker"
              [timeInMinutes]="timespot.extentedSettings.offsetTo"
              (timeInMinutesChange)="
                timespot.extentedSettings.offsetTo = $event
              "
            ></icn-time-picker>
          </div>
        </td>
        <td class="table-row extented-settings-row"></td>
        <td class="table-row extented-settings-row last pl8 pr8">
          <remove-button
            data-title="DELETE"
            (click)="resetExtentedSettings(timespot)"
            [overrideClass]="'hover-black'"
          ></remove-button>
        </td>
      </tr>
    </ng-container>
    <tr>
      <td>
        <a href="#" class="button" (click)="addNewTimeSpot()"
          >+ Add Time Spot</a
        >
      </td>
      <td></td>
    </tr>
  </table>
</div>
